import {Injectable} from '@angular/core';
import {TranslateLoader} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {Apollo} from "apollo-angular";
import {
  GET_ALL_TRANSLATIONS_KEYWORDS
} from "../store/entities/system-configurations/language-translation/language-translation.graphql";
import {
  LanguageTranslation
} from "../store/entities/system-configurations/language-translation/language-translation.model";

@Injectable({
  providedIn: 'root'
})
export class CustomTranslateLoader implements TranslateLoader {


  constructor(
    private apollo: Apollo,
  ) {
  }

  getTranslation(lang: string) {
    return new Observable<any>((observer) => {
      this.apollo.query({
        query: GET_ALL_TRANSLATIONS_KEYWORDS,
      }).toPromise()
        .then((response: any) => {
          let result: any = Object.values(response)[0];
          result = Object.values(result)[0];
          if (result?.response?.status) {
            const translationObj = {};
            result?.data.forEach((translation: LanguageTranslation) => {
              translationObj[translation?.keyword] = translation[lang];
            });
            observer.next(translationObj);
          } else {
            observer.next({});
          }
          observer.complete();
        })
        .catch((error: any) => {
          observer.error(error);
          observer.complete();
        });
    });
  }
}
